import React, { useState } from 'react';
import Modal, { ModalProps } from '@app/component/overlays/modal/Modal';
import Message from '@app/component/message/Message';
import useAppForm from '@app/site/_form';
import * as z from 'zod/v4';
import { SubmitButton } from '@app/site/_form/button/SubmitButton';
import HotelService from '@app/model/hotel/service/HotelService';

type ImportAirbnbModalProps = Omit<ModalProps, 'title'>;

const ImportAirbnbModal = React.memo(
	function ImportAirbnbModal({ ...props }: ImportAirbnbModalProps) {

		const [globalError, setGlobalError] = useState<string>();

		const form = useAppForm({
			defaultValues: {
				airbnbLink: '',
			},
			validators: {
				onChange: z.object({
					airbnbLink: z.url().nonempty(),
				}),
			},
			onSubmit: ({ value }) => HotelService.addHotelFromAirbnbUrl(value.airbnbLink)
				.then(() => {
					setGlobalError(undefined);
					props.ref.current?.close();
				})
				.catch((e: string) => {
					setGlobalError('Could not import hotel from this URL');
				}),
		});

		return <form.AppForm>
			<form onSubmit={
				(e) => {
					e.preventDefault();
					e.stopPropagation();
				}
			}>
				<Modal title="Import Airbnb" {...props} actions={
					<SubmitButton state="primary">Import</SubmitButton>
				}>
					<Message state="info">
						<ul role="list" className="list-disc space-y-1 pl-5 text-sm text-blue-700">
							<li>
								Provide the Airbnb's link below. Once added, you can set it at your current listing.
							</li>
							<li>
								Please note that the Airbnb must be from the surrounding property area.
							</li>
						</ul>
					</Message>
					{globalError && <Message state="error" onDismiss={() => setGlobalError(undefined)}>{globalError}</Message>}
					<div className="mt-8">
						<div className="flex justify-between"><label htmlFor="input-normal" className="label">Set Airbnb
							link</label>
						</div>
						<div className="mt-0.5">
							<form.AppField name="airbnbLink">
								{(field) => <field.TextField placeholder="Insert airbnb link" />}
							</form.AppField>
						</div>
					</div>
				</Modal>
			</form>
		</form.AppForm>;
	},
);

export default ImportAirbnbModal;